export { states } from './seatselection-routing.states';
export { config } from './seatselection-routing.config';
